module.exports = __webpack_public_path__ + "static/media/UQ.23a4593e.png";